import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { CURRENCIES } from "../../balanceSheetConstants";
import { FaChevronDown } from "react-icons/fa";

const CurrencyFilter = ({ handleApplyFilters, filters, isRTL, t }) => {
  const currentCurrency = CURRENCIES.find((c) => c.code === filters.currency);

  return (
    <Box h="full">
      <Menu>
        <MenuButton
          w="full"
          variant="outline"
          size="sm"
          textAlign={isRTL ? "right" : "left"}
          h="40px"
          display="flex"
          alignItems="center"
        >
          <HStack
            spacing={2}
            w="full"
            justify={isRTL ? "flex-end" : "flex-start"}
          >
            {isRTL && <Icon as={FaChevronDown} />}
            {currentCurrency?.symbol && <Text>{currentCurrency.symbol}</Text>}
            <Text noOfLines={1} flex={1}>
              {currentCurrency?.label || t("reports.select", "اختر")}
            </Text>
            {!isRTL && <Icon as={FaChevronDown} />}
          </HStack>
        </MenuButton>
        <MenuList maxH="300px" overflowY="auto">
          {CURRENCIES.map((currency) => (
            <MenuItem
              key={currency.code}
              onClick={() => handleApplyFilters({ currency: currency.code })}
              fontWeight={
                currency.code === filters.currency ? "bold" : "normal"
              }
              bg={currency.code === filters.currency ? "blue.50" : "white"}
              textAlign={isRTL ? "right" : "left"}
            >
              <HStack spacing={2}>
                <Text>{currency.symbol}</Text>
                <Text>{currency.label}</Text>
              </HStack>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};
export default CurrencyFilter;

